import { BaseContainerModel } from '../../base-container.model';
import { bl_cms_activities_hdr_RowClass } from '../../../dbschema';

export class CmsActivityContainerModel extends BaseContainerModel {
    bl_cms_activities_hdr: bl_cms_activities_hdr_RowClass = new bl_cms_activities_hdr_RowClass();
}